import React, { Component } from 'react';
import PropTypes from 'prop-types';

import StepperManager, {StepPropTypes} from '../StepperManager';
import { alertDialog } from '../../util/dialogs';
import PoiStepSourceForm from '../PoiStepSourceForm';
import PoiStepSettings from '../PoiStepSettings';
import PoiStepResults from '../PoiStepResults';
import PoiStepProcessing from '../PoiStepProcessing';
import PoiStepExport from '../PoiStepExport';

const standardErr = "If this problem persists, please contact Screen6 support.";

const styles = {
  stepperModule: {
    width: '100%',
    maxWidth: 1352,
    margin: 'auto',
    position: 'relative',
  },
}

/**
 * Configure the StepperManager component by adding Steps (StepperManager.stepperContentProvider)
 */
class PoiStepper extends Component {
  static contextTypes = {
    history: PropTypes.object.isRequired,
  }

  state = {
    stepIndex: undefined, // <-- will be set automatically by StepManager.onStepIndexChange -> this.handleStepIndexChange
  }

  handleStartOverClicked = () =>
    this.context.history.push(`/poi/restart`);

  handleStepIndexChange = (stepIndex) => {
    this.setState({stepIndex});
  }

  render() {
    const stepDescriptions = [
      'Select source data',
      'Configure',
      'Processing',
      'View results',
      'Export & download',
    ];

    // const onlyShowOnFirstStep = {
    //   display: this.state.stepIndex === 0 ? 'block' : 'none',
    // };

    return (
      <div style={styles.stepperModule}>
        <div className="PageHeading">
          <h1>POI Audience Service</h1>
          {/* <div style={onlyShowOnFirstStep}>
            <p>
              To test this feature:
            </p>
            <ol>
              <li>Use a US client, for example <i>IgnitionOne</i></li>
              <li>Upload a CSV file with two columns: column_1 should be titled <i>latitude</i>, column_2 should be titled <i>longitude</i></li>
            </ol>
          </div> */}
        </div>
        <StepperManager
          onStartOverClicked={this.handleStartOverClicked}
          onStepIndexChange={this.handleStepIndexChange}
          stepperContentProvider={PoiSteps}
          stepDescriptions={stepDescriptions}
        />
      </div>
    );
  }
}

const PoiSteps = ({stepIndex, onRefChange, onValidationChange, sessionHash, onHashChange, onNextStepFail, proceedAction, goBackAction}) => {
  switch (stepIndex) {
    case 0:
      return (
        <PoiStepSourceForm
          ref={ onRefChange }
          onValidationChange={ onValidationChange }
          onStepCompleteSuccess={
            uploadResponse => {
              onHashChange(uploadResponse.data);
              proceedAction();
            }
          }
          onStepCompleteFailed={ error => {
            onNextStepFail(error);
            alertDialog(
              standardErr
            );
          }}
        />
      );
    case 1:
      return (
        <PoiStepSettings
          ref={ onRefChange }
          onValidationChange={ onValidationChange }
          hash={ sessionHash }
          onStepCompleteSuccess={proceedAction}
          onStepCompleteFailed={
            error => {
              onNextStepFail(error);
              alertDialog(standardErr);
            }
          }
        />
      );
    case 2:
      return (
        <PoiStepProcessing
          ref={ onRefChange }
          hash={ sessionHash }
          onValidationChange={ onValidationChange }
          onStepCompleteSuccess={ proceedAction }
          onStepCompleteFailed={
            error => {
              onNextStepFail(error);
              alertDialog(standardErr);
              goBackAction();
            }
          }
        />
      );
    case 3:
      return (
        <PoiStepResults
          ref={ onRefChange }
          hash={ sessionHash }
        />
      );
    // Show the same content on the 4th and 5th step to show the checkmark when the export is finished.
    case 4:
    case 5:
      return (
        <PoiStepExport
          ref={ onRefChange }
          hash={ sessionHash }
          onStepCompleteSuccess={ proceedAction }
        />
      );
    default:
      return 'You\'re a long way from home sonny jim!';
  }
}
PoiSteps.propTypes = StepPropTypes;

export default PoiStepper;



// WEBPACK FOOTER //
// ./src/components/PoiStepper/index.jsx